import React, { useEffect, useRef, useState } from "react";
import { Accordion, AccordionSummary, Button, FormControl, Grid, makeStyles, TextField, Typography } from "@material-ui/core";
import { ValidatorForm } from "react-material-ui-form-validator";
import { crossImg, searchIcon } from "../../../../resources/images";
import { InputField } from "../../../../components/common";
import { useDebounce } from "../../../../utils/use-debounce";
import { FilterArrow, GridHide, GridShow, ListHide, ListShow } from "../../LeftNav/SvgIcons";
import { Autocomplete } from "@material-ui/lab";
import { ExpandMore } from "@material-ui/icons";
import { ChipItem } from "../Conversations/ConverstionSettings/GridFilter";
import { AutoComplete } from "../../../../components/common/FilterLayout/GridFilter";

const useStyless = makeStyles(theme => ({
    gridWrapper: {
        paddingTop: "29px",
        paddingBottom: "20px",
        borderBottom: "1px solid #E2E6E9",
        position: "relative",
        marginBottom: "20px",
    },
    chips: {
        display: "flex",
        flexWrap: "wrap",
    },
    MuiChip: {
        backgroundColor: "#CDE5FF",
        color: "#70808F",
        maxWidth: "99%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        textAlign: "left",
        margin: "0px 5px 5px 0px",
    },
    chip: {
        margin: 2,
    },
    dropdownBg: {
        background: "#f1f1f1",
    },
    formControl: {
        minWidth: "100%",
        background: "transparent",
    },
    selectEmpty: {
        border: "1px solid #F3F6F9",
        backgroundColor: "#F3F6F9",
        borderRadius: "6px",
        "&:before": {
            borderBottom: "1px solid #F3F6F9",
            "&:hover": {
                borderBottom: "0 !important",
            },
        },
        "&:after": {
            borderBottom: "1px solid #F3F6F9",
        },

        MuiSvgIcon: {
            root: {
                fontSize: 20,
            },
        },
    },
    MuiSelect: {
        icon: {
            fontSize: "26px",
        },
        iconOutlined: {
            fontSize: "26px",
        },
    },
    MuiFilledInput: {
        root: {
            "&:hover": {
                backgroundColor: "#F3F6F9",
            },
        },
    },
    dropdownWrapper: {
        width: "650px",
        padding: "15px 37px 40px 37px",
        position: "fixed",
        boxShadow: "0px 0px 13px 0px #ccc",
        right: "95px",
        marginTop: "-55px",
    },
}));

const handleSubmit = e => {
    e.preventDefault();
};

const statuses = [{ name: "In Use", id: 1 }, { name: "Not in use", id: 2 }];

export default function ContactTypesFilters({
    AppliedFilters,
    onApplyFilters,
    ActiveTabId,
    setActiveTabId,
    isListView,
    onToggleListView,
    ordersList,
    order,
    setOrderBy,
    title = `All Contact Types Filters`,
    allContactArea,
    allOfishRoles,
}) {

    const classes = useStyless();
    const [search, setSearchText] = useState("");
    const [ofishRole, setOfishRole] = useState("");
    const [contactArea, setContactArea] = useState("");
    const [contactCounts, setContactCounts] = useState("");
    const [status, setStatus] = useState("");
    const [applyFilter, setApplyFilter] = useState(null);
    const [isFilter, setIsFilter] = useState(false);

    const { debouncedValue: debouncedSearchTxt } = useDebounce(search, 500);

    const isFilterApplied = () => {
        return (
            ofishRole ||
            contactArea ||
            status ||
            contactCounts
        );
    };

    useEffect(() => {
        setSearchText(AppliedFilters?.search ?? "");
        setOfishRole(AppliedFilters?.ofishRole ?? "");
        setContactArea(AppliedFilters.contactArea ?? "");
        setStatus(AppliedFilters.status ?? "");
    }, [AppliedFilters]);

    const filtersCount =
        (ofishRole ? 1 : 0) +
        (contactArea ? 1 : 0) +
        (status ? 1 : 0) +
        (contactCounts ? 1 : 0);

    const applyFilters = () => {
        setApplyFilter(true);
        onApplyFilters(
            {
                search: search,
                ofishRole: ofishRole,
                contactArea: contactArea,
                status: status,
                contactCounts: contactCounts,
            },
            isFilterApplied()
        );
        setIsFilter(false);
    };

    useEffect(() => {
        applyFilters();
    }, [debouncedSearchTxt]);

    useEffect(() => {
        if (!filtersCount) {
            setApplyFilter(false)
        }
    }, [filtersCount]);


    const showFilter = () => {
        window.scroll(0, 0);
        setIsFilter(true);
    };

    return (
        <div className={classes.gridWrapper}>
            <ValidatorForm ref={useRef("contactTypeFilterForm")} onSubmit={handleSubmit}>
                <Grid container spacing={3}>
                    <Grid
                        item
                        md={9}
                        className={`filterMainSearch endUserSearchFilterMain pd-0`}
                    >
                        <img src={searchIcon} alt='' className="contactSearchIcon" />
                        <InputField
                            placeholder='Search'
                            value={search}
                            onKeyPress={({ key }) => {
                                if (["Enter", "enter"].includes(key)) applyFilters();
                            }}
                            onChange={({ target }) => {
                                setSearchText(target.value);
                            }}
                            onPaste={value => {
                                const splitValue = value.split("\n");
                                setSearchText(splitValue.join(", "));
                            }}
                        />
                        <span className={`endUserSearchFilter pt-0 pr-0`} onClick={showFilter}>
                            {(["4", "5", "6"].includes(ActiveTabId) && filtersCount > 1 && applyFilter) ||
                                (!["4", "5", "6"].includes(ActiveTabId) && filtersCount > 0 && applyFilter) ? (
                                <span>{`${filtersCount} Filter${filtersCount > 1 ? "(s)" : ""
                                    } Applied `}</span>
                            ) : null}
                            <FilterArrow color={"#fff"} />
                        </span>
                    </Grid>
                    <Grid item md={1} className='blockEndUserBtn pd-0'>
                        <span
                            onClick={() => {
                                onToggleListView(false);
                            }}>
                            {isListView ? <GridHide /> : <GridShow />}
                        </span>
                        <span
                            onClick={() => {
                                onToggleListView(true);
                            }}>
                            {isListView ? <ListShow /> : <ListHide />}
                        </span>
                    </Grid>
                    <Grid item md={2} className="pd-0">
                        <ValidatorForm ref={useRef("form")} onSubmit={handleSubmit}>
                            <div className='userDetailsSearchField inputWrapper filterSelect'>
                                <FormControl className='ac-dd'>
                                    <Autocomplete
                                        value={ordersList.find(x => x.id === order.orderVal)}
                                        onChange={(event, value) => setOrderBy({ ...order, orderVal: value.id })}
                                        multiple={false}
                                        filterSelectedOptions={false}
                                        id='order-value'
                                        options={ordersList}
                                        getOptionLabel={option => option?.value || ""}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                inputProps={{ ...params.inputProps, autoComplete: 'none' }}
                                                placeholder={"Recently Updated"} />
                                        )}
                                    />
                                </FormControl>
                            </div>
                        </ValidatorForm>
                    </Grid>
                </Grid>
                {isFilter && (
                    <div className='endUserFilterWrapper'>
                        <div className='endUserFilterInnerWrapper'>
                            <img
                                className='filterCrossImage'
                                src={crossImg}
                                alt='cross icon'
                                onClick={() => setIsFilter(false)}
                            />
                            <div className='formContainer'>
                                <h3>{title}</h3>
                                <Accordion
                                    defaultExpanded
                                    id='end-user-filter-expandable'
                                    TransitionProps={{ unmountOnExit: true }}
                                >
                                    <AccordionSummary expandIcon={<ExpandMore />}>
                                        <Typography>
                                            <span>Active Filters</span>
                                            <span>
                                                <Button
                                                    className='filterClearBtn'
                                                    variant='outlined'
                                                    onClick={() => {
                                                        onApplyFilters(
                                                            {
                                                                search: "",
                                                                ofishRole: "",
                                                                contactArea: "",
                                                                status: "",
                                                                contactCounts: "",
                                                            },
                                                            false
                                                        );
                                                        setIsFilter(false);
                                                    }}
                                                >
                                                    Clear
                                                </Button>
                                            </span>
                                        </Typography>
                                    </AccordionSummary>
                                    <div>
                                        {filtersCount <= 0 && (
                                            <div className={`filtersChips`}>No Active Filter(s)</div>
                                        )}
                                        {(contactArea) && (
                                            <ChipItem
                                                chipLabel='Contact Area'
                                                chipValue={`${allContactArea.find(x => x.id === contactArea)?.name}`}
                                                onDelete={() => {setContactArea("")}}
                                            />
                                        )}
                                        {(ofishRole) && (
                                            <ChipItem
                                                chipLabel='OFish Role'
                                                chipValue={`${allOfishRoles.find(x => x.id === ofishRole)?.name}`}
                                                onDelete={() => {setOfishRole("")}}
                                            />
                                        )}
                                        {(contactCounts) && (
                                            <ChipItem
                                                chipLabel='Contact Counts'
                                                chipValue={`${contactCounts}`}
                                                onDelete={() => {setContactCounts("")}}
                                            />
                                        )}
                                        {(status) && (
                                            <ChipItem
                                                chipLabel='Contact Type Status'
                                                chipValue={`${status}`}
                                                onDelete={() => {setStatus("")}}
                                            />
                                        )}
                                    </div>
                                </Accordion>
                                <div style={{ marginTop: "10px" }}></div>
                                <div className='userDetailsSearchField inputWrapper filterSelect'>
                                    <AutoComplete
                                        value={allContactArea.find(x => x.id === contactArea)}
                                        onChange={(event, value) => {
                                            setContactArea(value.id);
                                        }}
                                        id='contactArea'
                                        options={allContactArea}
                                        getOptionLabel={option => option?.name || ""}
                                        placeholder={"Contact Area"}
                                    />
                                </div>
                                <div style={{ marginTop: "5px" }}></div>
                                <div className='userDetailsSearchField inputWrapper filterSelect'>
                                    <AutoComplete
                                        value={allOfishRoles.find(x => x.id === ofishRole)}
                                        onChange={(event, value) => {
                                            setOfishRole(value.id);
                                        }}
                                        id='ofishRole'
                                        options={allOfishRoles}
                                        getOptionLabel={option => option?.name || ""}
                                        placeholder={"OFish Role"}
                                    />
                                </div>
                                <div style={{ marginTop: "5px" }}></div>
                                <div className='userDetailsSearchField inputWrapper filterSelect'>
                                    <AutoComplete
                                        value={statuses.find(x => x.name === status)}
                                        onChange={(event, value) => {
                                            setStatus(value.name);
                                        }}
                                        id='status'
                                        options={statuses}
                                        getOptionLabel={option => option?.name || ""}
                                        placeholder={"Status"}
                                    />
                                </div>
                            </div>
                            <div className='endUserfilrerBtn'>
                                <Button
                                    variant='contained'
                                    onClick={() => {
                                        applyFilters();
                                    }}>
                                    Apply Filter
                                </Button>
                            </div>
                        </div>
                    </div>
                )}
            </ValidatorForm>
        </div>
    );
};
